(() => {
  if (window.__ga4ScrollTrackingInitialized) return;
  if (typeof window.trackGA4Event !== 'function') return;

  window.__ga4ScrollTrackingInitialized = true;

  const scrollThresholds = Array.from({ length: 10 }, (_, index) => (index + 1) * 10);
  const trackedScrollThresholds = new Set();
  let scrollFrameRequested = false;

  const getScrollPercentage = () => {
    const documentElement = document.documentElement;
    const body = document.body;
    const viewportHeight = window.innerHeight || documentElement.clientHeight || 0;
    const documentHeight = Math.max(
      documentElement.scrollHeight,
      documentElement.offsetHeight,
      documentElement.clientHeight,
      body?.scrollHeight || 0,
      body?.offsetHeight || 0,
      body?.clientHeight || 0,
    );
    const scrollableHeight = documentHeight - viewportHeight;

    if (scrollableHeight <= 0) return 0;

    const scrollTop =
      window.scrollY ||
      window.pageYOffset ||
      document.scrollingElement?.scrollTop ||
      documentElement.scrollTop ||
      0;

    if (scrollTop + viewportHeight >= documentHeight - 1) return 100;

    return Math.min(100, Math.floor((scrollTop / scrollableHeight) * 100));
  };

  const trackScrollDepth = () => {
    const scrollPercentage = getScrollPercentage();

    scrollThresholds.forEach((threshold) => {
      if (scrollPercentage < threshold || trackedScrollThresholds.has(threshold)) return;

      trackedScrollThresholds.add(threshold);
      window.trackGA4Event({
        event_name: `scroll_${threshold}`,
        event_parameters: {
          current_page: window.location.href,
        },
      });
    });
  };

  const handleScroll = () => {
    if (scrollFrameRequested) return;

    scrollFrameRequested = true;
    window.requestAnimationFrame(() => {
      trackScrollDepth();
      scrollFrameRequested = false;
    });
  };

  window.addEventListener('scroll', handleScroll, { passive: true });
})();
